import { Collapse } from "antd";
import styled from "styled-components";

import { PrimaryText } from "../Typography";

export const StyledTAColumnNameText = styled(PrimaryText)`
    font-weight: 400;
    font-size: 12px;
    line-height: 130%;
    letter-spacing: 0%;
    text-align: center;
`;

export const StyledTAValueText = styled(PrimaryText)`
    font-weight: 400;
    font-size: 12px;
    line-height: 130%;
    letter-spacing: 0%;
    text-align: center;
    color: ${(props) => props.theme.lightBlue} !important;
`;

export const StyledTATotalSumText = styled(PrimaryText)`
    font-weight: 500;
    font-size: 14px;
    line-height: 120%;
    letter-spacing: 0%;

    color: ${(props) => props.theme.lightBlue} !important;
`;

export const StyledTACollapseWrapper = styled.div`
    width: 100%;
    max-width: ${(props) => props.theme.maxContentWidth};
    display: flex;
    justify-content: center;
`;

export const StyledTACollapse = styled(Collapse)`
    border: none;
    border-radius: 0;
    width: 100%;
    background-color: transparent;

    .ant-collapse-item:last-child > .ant-collapse-header,
    .ant-collapse-item:last-child > .ant-collapse-content {
        border-radius: 0;
    }

    .ant-collapse-content-box {
        padding: 0px !important;
    }

    .ant-collapse-item {
        background-color: transparent !important;
    }
    .ant-collapse-header {
        background-color: ${(props) => props.theme.darkBlue} !important;
        padding: 10px 16px !important;
        border-radius: 8px !important;
    }

    .ant-collapse-content {
        background-color: ${(props) => props.theme.darkBlue} !important;
        border-color: ${(props) => props.theme.middleBlue} !important;
    }

    .ant-collapse-item-active {
        .ant-collapse-header {
            border-radius: 8px 8px 0 0 !important;
        }
    }
`;

export const StyledTATableWrapper = styled.div`
    width: 100%;
    .ant-table-cell {
        padding: 12px 0 !important;
    }

    table {
        border-radius: 0px !important;
    }

    .ant-table,
    .ant-table-cell {
        background: transparent !important;
    }

    tr,
    .ant-table,
    colgroup,
    .ant-table-container {
        border-radius: 0px !important;
    }

    th {
        border-start-start-radius: 0px !important;
        border-start-end-radius: 0px !important;
    }

    td,
    th,
    .ant-table-container {
        border-color: ${(props) => props.theme.middleBlue} !important;
    }
`;
